import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { GForceCalc } from "../components/GForceCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.gf_tool_name()}
        toolPath="/g-force-calculator"
      />
      <SciHeader title={m.gf_h1()} intro={m.gf_intro()} />
      <GForceCalc />
      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.gf_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.gf_ex1(), m.gf_ex2(), m.gf_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.gf_faq_q1(), a: m.gf_faq_a1() },
          { q: m.gf_faq_q2(), a: m.gf_faq_a2() },
          { q: m.gf_faq_q3(), a: m.gf_faq_a3() },
          { q: m.gf_faq_q4(), a: m.gf_faq_a4() },
        ]}
      />
      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
